export const STORAGE_KEYS = {
  token: "token",
  lastURL: "lastURL",
  user: "user",
  userId: "userId",
  prodURL: "productUrl",
};

export const APP_ID = "3";
